<template>
  <v-main>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-3">
          <v-card-title>
            <span>Summary</span>
            <v-btn icon color="blue" :disabled="loading" @click="getRecordsCount">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle>Operational data</v-card-subtitle>
          <v-card-text>
            <span v-for="h in oper_tables" :key="h" class="pa-2 elevation-3 main-span mx-2">
              <span class="mr-2">{{ h.text }}</span>
              <span class="blue--text font-weight-black">{{h.count}}</span>
            </span>
          </v-card-text>
          <v-card-subtitle>Structure data</v-card-subtitle>
          <v-card-text>
            <span v-for="h in struct_tables" :key="h" class="pa-2 elevation-3 main-span mx-2">
              <span class="mr-2">{{ h.text }}</span>
              <span class="blue--text font-weight-black">{{h.count}}</span>
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-3">
          <v-card-title>
            <i18n path="admin.logst1" />
            <v-btn icon color="blue" @click="prepare" :disabled="loading">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="d-flex">
              <div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  max-width="450px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      :label="$t('admin.until')"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    no-title
                    scrollable
                    :max="$moment().subtract(2, 'years').format('YYYY-MM')"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <v-checkbox v-model="cb_1100" :label="$t('admin.cb1100')" class="ml-4"></v-checkbox>
              <v-checkbox v-model="cb_1000" :label="$t('admin.cb1000')" class="ml-4"></v-checkbox>
              <v-checkbox v-model="cb_900" :label="$t('admin.cb900')" class="ml-4"></v-checkbox>
            </div>
            <div>
              <i18n v-if="count" path="label.found" class="headline">
                <template #count>
                  <span class="primary--text">{{count}}</span>
                </template>
              </i18n>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-3">
          <v-card-title>
            <span>CARDS</span>
            <v-btn icon color="blue" @click="getBlockedCards" :disabled="loading">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-pagination
              v-if="blockedCardsLen"
              v-model="page"
              :length="blockedCardsPages"
              circle
              total-visible="10"
            ></v-pagination>
            <v-simple-table dense>
              <thead>
                <tr class="grey lighten-4">
                  <th v-for="h in cardheader" :key="h">{{h}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="card in blockedCardsPage" :key="card.id">
                  <td v-for="h in cardheader" :key="h">{{card[h]}}</td>
                </tr>
                <tr class="grey lighten-4">
                  <td>{{blockedCardsLen}}</td>
                  <td></td>
                  <td>{{detailsCount}}</td>
                  <td>{{transCount}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import app from "@/app.js";

export default {
  name: "TablesUtils",
  data() {
    return {
      page: 0,
      count: 0,
      blockedCards: [],
      detailsCount: 0,
      transCount: 0,
      loading: false,
      menu: false,
      maxdate: null,
      date: null,
      cb_1100: true,
      cb_1000: true,
      cb_900: true,

      oper_tables: [
        { text: "LOG", table: "log", count: 0 },
        { text: "BASIC", table: "basic", count: 0 },
        { text: "CARD", table: "card", count: 0 },
        { text: "DETAILS", table: "cdet", count: 0 },
        { text: "TRANSACTIONS", table: "trans", count: 0 },
        { text: "ACTIVITY", table: "logact", count: 0 },
        { text: "REPORTS", table: "report", count: 0 },
      ],
      struct_tables: [
        { text: "Systems", table: "systems", count: 0 },
        { text: "Operations", table: "sdet", count: 0 },
        { text: "Terminals", table: "term", count: 0 },
        { text: "TermDet", table: "tdet", count: 0 },
        { text: "Users", table: "user", count: 0 },
        { text: "Groups", table: "group", count: 0 },
        { text: "Messages", table: "error", count: 0 },
      ],
      cardheader: ["id", "status", "details", "trans"],
    };
  },
  computed: {
    blockedCardsLen() {
      return this.blockedCards.length;
    },
    blockedCardsPages() {
      return this.blockedCardsLen ? Math.ceil(this.blockedCardsLen / 6) : 0;
    },
    blockedCardsPage() {
      return this.blockedCardsLen
        ? this.blockedCards.slice((this.page - 1) * 6, this.page * 6)
        : [];
    },
  },
  methods: {
    getRecordsCount() {
      this.loading = true;
      app
        .baseUtilsLogCount()
        .then((res) => {
          this.oper_tables.forEach((e) => {
            e.count = res[e.table];
          });
          this.struct_tables.forEach((e) => {
            e.count = res[e.table];
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    getBlockedCards() {
      this.loading = true;
      app
        .baseUtilsBlockedCards()
        .then((res) => {
          this.blockedCards = res.data;
          this.blockedCards.forEach((e) => {
            if (e.details) this.detailsCount += e.details;
            if (e.trans) this.transCount += e.trans;
          });
          this.page = 1;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    prepare() {
      this.loading = true;
      app
        .baseUtilsLogPrepare({
          cb1100: this.cb_1100,
          cb1000: this.cb_1000,
          cb900: this.cb_900,
          date: this.date ? this.$moment(this.date).format("YYYY-MM") : null,
        })
        .then((res) => {
          this.count = res.count;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-span {
  border-radius: 25px;
}
</style>